<template>
  <div class="vuetable-filter-bar">
    <div class="form-inline">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group mr-5" v-if="filterByDate.startDate">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary" type="button" @click="resetDateFilter"><i class="fas fa-times"/></button>
            </div>
            <input v-model="filterByDate.startDate"
                   class="form-control"
                   :placeholder="$t('_search')"
                   type="date"
                   @keyup.enter="doDateFilter"
            >
            <input v-model="filterByDate.endDate"
                   class="form-control"
                   :placeholder="$t('_search')"
                   type="date"
                   @keyup.enter="doDateFilter"
            >
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="doDateFilter"><i class="fas fa-search"/></button>
            </div>
          </div>
          <div class="input-group-prepend">
              <button class="btn btn-outline-secondary" type="button" @click="resetFilter"><i class="fas fa-times"/></button>
          </div>
          <input v-model="filterText"
                 class="form-control"
                 :placeholder="$t('_search')"
                 type="text"
                 @keyup.enter="doFilter"
          >
          <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="doFilter"><i class="fas fa-search"/></button>
          </div>

          <div class="input-group-append help-dates" v-if="helpDates">
            <div class="text-left">Pour une recherche par date, respecter le motif suivant : AAAA-MM-JJ</div>
            <div class="examples">
              <span>Exemples</span>
              <table>
                <tr>
                  <td>2020-11-19</td>
                  <td>le 19 novembre 2020</td>
                </tr>

                <tr>
                  <td>2020-11</td>
                  <td>une date quelconque du mois de novembre 2020</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      filterText: ''
    }
  },

  props: {
    helpDates: Boolean,
    filterByDate: {
      type: Object,
      default: () => {
        return {
          startDate: null,
          endDate: null
        }
      }
    },
    originalFilterByDate: {
      type: Object,
      default: () => {
        return {
          startDate: null,
          endDate: null
        }
      }
    }
  },

  created () {
    this.originalFilterByDate.startDate = this.filterByDate.startDate
    this.originalFilterByDate.endDate = this.filterByDate.endDate
  },

  methods: {
    doDateFilter () {
      this.$events.fire('filter-date-set', this.generateEventArgs())
      this.$emit('filter-date', this.generateEventArgs())
    },

    doFilter () {
      this.$events.fire('filter-set', this.generateEventArgs())
      this.$emit('filter', this.generateEventArgs())
    },

    resetDateFilter () {
      this.filterByDate.startDate = this.originalFilterByDate.startDate
      this.filterByDate.endDate = this.originalFilterByDate.endDate
      this.$events.fire('filter-date-reset')
      this.$emit('filter-date', this.generateEventArgs())
    },

    resetFilter () {
      this.filterText = ''
      this.$events.fire('filter-reset')
      this.$emit('filter', this.generateEventArgs())
    },

    generateEventArgs () {
      let args = {
        filterText: this.filterText,
        filterStartDate: this.filterByDate.startDate,
        filterEndDate: this.filterByDate.endDate
      }
      return args
    }
  }
}
</script>

<style lang="scss">
  .help-dates {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
    font-size: 0.8rem;

    .examples {
      display: flex;
      flex-direction: row;
      font-size: 0.7rem;

      table {
        td {
          padding-left: 0.5rem;
          font-size: 0.7rem;
          text-align: left;

          &:first-child:after {
            content: ' :'
          }
        }
      }
    }
  }
</style>
